<section class="ship-from-ship-to">
  <div class="ship-from-ship-to__wizard-top">
    <app-serviceability-error-banner />
    <app-system-error-banner />
    <app-shipment-stepper [activeStepIndex]="activeStepIndex" />
  </div>

  @if (showPageSkeleton()) {
    <div class="ship-from-ship-to__content" aria-busy="true">
      <app-ship-from-ship-to-skeleton />
    </div>
  } @else {
    <form class="ship-from-ship-to__form" [formGroup]="form" autocomplete="off">
      @for (sectionKey of [shipFromSectionKey()]; track sectionKey) {
        <app-address-form-section
          sectionKey="shipFrom"
          [addressLinesExpanded]="form.controls['shipFromAddressLinesExpanded'].value === true"
          [submitted]="shipFromSubmitted()"
          [validationAttempt]="validationAttempt()"
          [addressSuggestion]="shipFromSuggestion()"
          (clearRequested)="onClearSection('shipFrom')"
          (expandLinesRequested)="onExpandAddressLines('shipFrom')"
          (streetAddressSuggestionSelected)="onStreetAddressSuggestionSelected('shipFrom', $event)"
          (useSuggestedAddress)="onUseSuggestedAddress('shipFrom')"
          (keepSuggestedAddressEntry)="onKeepSuggestedAddressEntry('shipFrom')"
        />
      }

      @for (sectionKey of [shipToSectionKey()]; track sectionKey) {
        <app-address-form-section
          sectionKey="shipTo"
          [addressLinesExpanded]="form.controls['shipToAddressLinesExpanded'].value === true"
          [showReturnAddressToggle]="true"
          [useDifferentReturnAddress]="form.controls['useDifferentReturnAddress'].value === true"
          [submitted]="shipToSubmitted()"
          [validationAttempt]="validationAttempt()"
          [addressSuggestion]="shipToSuggestion()"
          [showMissingUnitSuiteWarning]="shipToMissingUnitSuiteWarning()"
          (clearRequested)="onClearSection('shipTo')"
          (expandLinesRequested)="onExpandAddressLines('shipTo')"
          (streetAddressSuggestionSelected)="onStreetAddressSuggestionSelected('shipTo', $event)"
          (useDifferentReturnAddressChange)="onUseDifferentReturnAddressChange($event)"
          (useSuggestedAddress)="onUseSuggestedAddress('shipTo')"
          (keepSuggestedAddressEntry)="onKeepSuggestedAddressEntry('shipTo')"
        />
      }

      @if (form.controls['useDifferentReturnAddress'].value === true) {
        @for (sectionKey of [returnAddressSectionKey()]; track sectionKey) {
          <app-return-address-section
            [addressLinesExpanded]="form.controls['returnAddressLinesExpanded'].value === true"
            [submitted]="returnAddressSubmitted()"
            [validationAttempt]="validationAttempt()"
            [addressSuggestion]="returnAddressSuggestion()"
            (clearRequested)="onClearSection('returnAddress')"
            (expandLinesRequested)="onExpandAddressLines('returnAddress')"
            (streetAddressSuggestionSelected)="
              onStreetAddressSuggestionSelected('returnAddress', $event)
            "
            (useSuggestedAddress)="onUseSuggestedAddress('returnAddress')"
            (keepSuggestedAddressEntry)="onKeepSuggestedAddressEntry('returnAddress')"
          />
        }
      }

      <app-shipment-form-actions
        [loading]="saveAndContinueInProgress()"
        (saveRequested)="onSaveAndContinue()"
      />
    </form>
  }
</section>
